import { CircleAlert } from "lucide-react";
import { useId, type ReactNode } from "react";

type ChangeRequestCardProps = {
  title: string;
  isLoading?: boolean;
  isError?: boolean;
  onRetry?: () => void;
  actions?: ReactNode;
  footer?: ReactNode;
  actionsPlacement?: "header" | "footer";
};

export function ChangeRequestCard({
  title,
  isLoading,
  isError,
  onRetry,
  actions,
  footer,
  actionsPlacement = "footer",
}: ChangeRequestCardProps) {
  const titleId = useId();

  return (
    <section
      className="change-request-section action-panel"
      aria-labelledby={titleId}
    >
      <header
        className="change-request-header action-panel-head"
        data-actions-in-header={actionsPlacement === "header" || undefined}
      >
        {actionsPlacement === "footer" && (
          <span className="change-request-header-icon" aria-hidden="true">
            <CircleAlert size={18} />
          </span>
        )}
        <div className="change-request-header-heading">
          <h3 className="change-request-title" id={titleId}>
            {title}
          </h3>
          {actionsPlacement === "header" && (
            <span className="change-request-status">Pendente</span>
          )}
        </div>
        {actionsPlacement === "header" ? (
          !isLoading &&
          !isError &&
          actions && (
            <div className="change-request-actions change-request-header-actions row-actions">
              {actions}
            </div>
          )
        ) : (
          <span className="change-request-status">Pendente</span>
        )}
      </header>

      {isLoading && (
        <p className="change-request-loading" role="status">
          Carregando alterações...
        </p>
      )}

      {!isLoading && isError && (
        <div className="change-request-error" role="alert">
          <p>Não foi possível carregar as alterações.</p>
          {onRetry && (
            <button
              type="button"
              className="order-action-button neutral"
              onClick={onRetry}
            >
              Tentar novamente
            </button>
          )}
        </div>
      )}

      {!isLoading && !isError && footer && (
        <div className="change-request-content change-request-footer action-panel-body">
          {footer}
        </div>
      )}

      {actionsPlacement === "footer" && !isLoading && !isError && actions && (
        <div className="change-request-actions action-panel-foot">
          {actions}
        </div>
      )}
    </section>
  );
}
